import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import store from 'store';
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';
import { translation } from 'helpers/utilsHelper.js';
import { renderField, renderPasswordField, renderCheckboxWithSpoiler, handleChatClick } from 'helpers/registerHelper.js';
import S from './StyledRegisterFormByMyIdStep3.js';

const validate = values => {
    const errors = validation(values, validators.REGISTER_BANK_STEP3);
    return errors;
};

const RegisterFormByMyIdStep3 = ({ 
   handleSubmit, 
    submitting, 
    error, 
    dispatch,
    ageConsentVal,
    marketingVal,
    emailActivationVal,
    bonusVal,
    selectAllStep3Val 
}) => {
    const spoilerTranslations = {
        moreText: translation('common_more'),
        lessText: translation('common_less')
    };

    useEffect(() => {
        const areAllChecked = !!(ageConsentVal && marketingVal && bonusVal);
        
        if (areAllChecked !== !!selectAllStep3Val) {
            dispatch(change('registerWizardForm', 'selectAllStep3', areAllChecked));
        }
    }, [ageConsentVal, marketingVal, bonusVal, dispatch]);

    const handleSelectAll = (event, newValue) => {
        dispatch(change('registerWizardForm', 'ageConsent', newValue));
        dispatch(change('registerWizardForm', 'marketingConsent', newValue));
        dispatch(change('registerWizardForm', 'bonus', newValue));
    };

    return (
        <S.FormStep3 onSubmit={handleSubmit}>
            {error && <S.SubmissionError className="submission-error">{error}</S.SubmissionError>}
            
            <S.InputsSection>
                <Field name="email" component={renderField} S={S} label={translation('registerFormBank_email')} type="text" />
                <Field name="password" component={renderPasswordField} S={S} label={translation('registerFormBank_password')} />
                <Field name="mobile" component={renderField} S={S} label={translation('registerFormBank_phoneNumber')} type="text" />
            </S.InputsSection>

            <S.ConsentsSection>
                <Field name="selectAllStep3" component={renderCheckboxWithSpoiler} S={S} labelPart1={translation('registerFormBank_marketingSelectAll')} onChange={handleSelectAll}{...spoilerTranslations}/>
                <Field name="ageConsent" component={renderCheckboxWithSpoiler} S={S} labelPart1={translation('registerFormBank_rodoClause')} labelPart2={translation('registerFormBank_rodoClauseAdditional')}{...spoilerTranslations}/>
                <Field name="marketingConsent" component={renderCheckboxWithSpoiler} S={S} labelPart1={translation('registerFormBank_marketingReceiveEmail')}{...spoilerTranslations}/>
                
                <S.AdminInfo>{translation('registerFormBank_adminNote')}</S.AdminInfo>

                <Field name="emailActivation" component={renderCheckboxWithSpoiler} S={S} labelPart1={translation('registerFormBank_consentEmailActivation')}{...spoilerTranslations}/>
                <Field name="bonus" component={renderCheckboxWithSpoiler} S={S} labelPart1={translation('registerFormBank_consentBonus')}{...spoilerTranslations}/>
            </S.ConsentsSection>

            <S.SubmitBtn type="submit" disabled={submitting}>
                {translation('registerFormBank_submit')}
            </S.SubmitBtn>

            <S.FooterInfo>
                <S.ContactInfo>{translation('registerFormBank_needHelp')}</S.ContactInfo>
                <S.ContactLink onClick={handleChatClick}>
                    {translation('registerFormBank_contactUs')}
                </S.ContactLink>
            </S.FooterInfo>
        </S.FormStep3>
    );
};

const selector = formValueSelector('registerWizardForm');

const mapStateToProps = (state) => {
    return {
        ageConsentVal: selector(state, 'ageConsent'),
        marketingVal: selector(state, 'marketingConsent'),
        emailActivationVal: selector(state, 'emailActivation'),
        bonusVal: selector(state, 'bonus'),
        selectAllStep3Val: selector(state, 'selectAllStep3')
    };
};

const connectedForm = connect(mapStateToProps)(RegisterFormByMyIdStep3);

export default reduxForm({
    form: 'registerWizardForm',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(connectedForm);